// extracted by mini-css-extract-plugin
export default {"footer-container":"Footer_footer-container__Ocrdn"};